import { useNavigate } from "react-router-dom";
import urls from "../../config/urls.json";
import { useSession } from "../../hooks/useSession";
import { ApiService as api } from "../../services/ApiService";
import { useStates } from "../../hooks/useStates";
import { isCf } from "../../services/validators";
import { useEffect, useState } from "react";
import { useEditAppointment } from "../../hooks/useEditAppointment";
import { useDynatrace } from "../../hooks/useDynatrace";

export const useCodiceFiscalePage = () => {
    const navigate = useNavigate();
    const { read, update, batchUpdate, setC5 } = useSession();
    const { states, setCurrentState, isDatiUtenteReady, isCfFetchStart, isCfFetchError, isCfEditAppointment } = useStates();
    const { showModal, closeModal, setCodiceFiscale, codiceFiscale, codiceFiscaleError, askForEditAppointment } = useEditAppointment();

    const [fetchError, setFetchError] = useState(false);
    const [fetchErrorMessage, setFetchErrorMessage] = useState("");

    useEffect(() => {
        setCurrentState(states.LOAD_FILIALI_SLIDES_END);
        update("codiceFiscale", "");
    }, []);

    const {} = useDynatrace();

    const ric = () => {
        navigate(urls.datiPersonaliRiconosciuto.path);
    };
    const nonRic = () => {
        navigate(urls.datiPersonaliNonRiconosciuto.path);
    };
    const clink = () => {
        navigate(urls.clink.path);
    };
    const c5 = () => {
        navigate(urls.luogoC5.path);
    };
    const onCfChange = async (value) => {
        setCurrentState(states.BUSY);
        update("codiceFiscale", value);

        if (value.length < 16) return;

        if (!isCf(value)) {
            setCurrentState(states.FETCH_CF_ERROR);
            return;
        }

        setCurrentState(states.FETCH_CF_START);

        let cfResult = {};
        try {
            // cfResult = await api.CheckByCFAsync({
            //   cf: value,
            // });
            cfResult = await api.GetUserDataAndAppointmentByCf({
                CodiceFiscale: value,
            });
        } catch (error) {
            setFetchErrorMessage("C'è stato un errore con il codice fiscale inserito. <br />Per favore riprova.");
            setFetchError(true);
            setCurrentState(states.LOAD_FILIALI_SLIDES_END);
            return;
        }

        // if App, stop and switch to c5 flow
        // if(cfResult.app) {
        // if (cfResult.isAlreadyPP) {
        // @???
        if (cfResult.isAlreadyC5) {
            update("codiceFiscale", value);
            setC5();
            return;
        }

        // let's see if he has an appointment already
        update("oppID", "");

        // WAF...
        // if (!cfResult.appuntamento) {
        if (!cfResult.hasOwnProperty("appointmentData")) {
            setFetchErrorMessage("C'è stato un errore con il codice fiscale inserito. <br />Per favore riprova.");
            setFetchError(true);
            setCurrentState(states.LOAD_FILIALI_SLIDES_END);
            return;
        }
        // const oppID = cfResult.appuntamento.oppID;
        // if (null != oppID) {
        if (cfResult.appointmentData && !!cfResult.appointmentData.appointmentId) {
            setCurrentState(states.FETCH_CF_EDIT_APPOINTMENT);
            askForEditAppointment();
            return;
        }

        update("ricontattoCf", cfResult.ricontatto || cfResult.Ricontatto);

        // const utente = cfResult.appuntamento.utente;
        const utente = cfResult.datiCliente || {};
        const mergeableFields = {
            // utenteRiconosciuto: null != utente.codice_fiscale,
            utenteRiconosciuto: !!utente.codiceFiscale,
        };
        mergeableFields["nome"] = utente.nome || "";
        mergeableFields["cognome"] = utente.cognome || "";
        mergeableFields["email"] = utente.email || "";
        // mergeableFields["cellulare"] = utente.telefono || "";
        mergeableFields["cellulare"] = utente.cellulare || utente.telefono || "";
        // mergeableFields["capResidenza"] = utente.cap || "";
        mergeableFields["capResidenza"] = utente.capResidenza || utente.cap || "";
        // if(cfResult.suggestC5 === true) {
        if (cfResult.isAlreadyC5 === true) {
            mergeableFields["prodotto"] = 3;
        }
        batchUpdate(mergeableFields);
        setCurrentState(states.FETCH_CF_END);
    };

    const next = () => {
        if (read("prodotto") == 3) {
            //Arriviamo da suggestC5
            c5();
        } else if (true == read("ricontattoCf") && true == read("ricontattoLuogo")) {
            update("ricontatto", true);
            clink();
        } else if (true == read("utenteRiconosciuto")) {
            ric();
        } else {
            nonRic();
        }
    };

    const getCfInputState = () => {
        return isCfFetchError() ? 4 : isCf(read("codiceFiscale")) ? 3 : 1;
    };

    return {
        read,
        update,
        onCfChange,
        next,
        nonRic,
        ric,
        clink,
        isDatiUtenteReady,
        isCfFetchStart,
        isCfFetchError,
        isCfEditAppointment,
        getCfInputState,
        fetchErrorMessage,
        fetchError,
        setFetchError,
        showModal,
        closeModal,
        setCodiceFiscale,
        codiceFiscale,
        codiceFiscaleError,
        askForEditAppointment,
    };
};
